import React from 'react';
import { BackgroundIcon } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { SVGIcon } from '@superops/super-icons';

function PatchCategoryCell(props) {
  const { cell } = props;

  const category =
    cell?.row?.original?.category || cell?.row?.original?.patchDetail?.category;

  return (
    <div className="flex-row flex-align-center">
      {category === 'Security Updates' && (
        <div style={{ height: '20px', width: '25px' }}>
          <div className="fx center">
            <SVGIcon name="Security" color="#DC5142" />
          </div>
        </div>
      )}
      <div>{category ? category : <DisabledTag>NA</DisabledTag>}</div>
    </div>
  );
}

export default PatchCategoryCell;
